import React from 'react'

const CardBody = props => (
    <div className="card-body">
        { props.children }
    </div>
)

export default CardBody